import React, { useMemo } from 'react';
import LoggedInNavItems from '@fingo/lib/components/layout/navbar/LoggedInNavItems';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { useApolloClient } from '@apollo/client';
import { logOut } from '@fingo/lib/apollo/helpers/auth';
import NavbarLink from '@fingo/lib/components/links/NavbarLink';
import useMartinaRoutes from '../../../hooks/useMartinaRoutes';

const LoggedInDesktopNavItems = () => {
  const client = useApolloClient();
  const theme = useTheme();
  const { navbarHeight } = theme.components.MuiToolbar;
  const martinaRoutes = useMartinaRoutes();
  const routes = useMemo(
    () => martinaRoutes.filter(({ showInNavbar }) => !!showInNavbar),
  );
  return (
    <Stack
      width="100%"
      direction="row"
      spacing={4}
      height={navbarHeight}
      alignItems="center"
      justifyContent="space-between"
      ml={4}
    >
      <LoggedInNavItems routes={routes} />
      <Stack direction="row" spacing={1}>
        <NavbarLink
          id="logout"
          title="Cerrar sesión"
          to="/login"
          onClick={() => { logOut(client); }}
        />
      </Stack>
    </Stack>
  );
};

export default LoggedInDesktopNavItems;
